'use strict';

angular.module('shiftTraderApp')
  .factory('OverrideTokens', function (ServerUrls, $http, $q, Session, UserPermissionsService) {
    function getBaseUrl() {
      return ServerUrls.current.railsApi + 'organizations/' + Session.getCurrentOrgId() + '/override';
    }

    // Fetch permissions
    var permissionsToFetch = [

    ];

    //the Model
    var OverrideToken = function(initData) {
      var O = {};
      angular.extend(O, initData);

      if (lodash.has(O, 'expires_at')) {
        O._expires_at = moment(O.expires_at);
      }

      // function processRawPermissions(rawPerms) {
      //   var isMyNote = M.user.id == Session.me;
      //   var myPermLevel = (rawPerms['media.view_public']) ? 0 : -1;
      //   myPermLevel = (rawPerms['media.view_management']) ? 1 : myPermLevel;
      //   myPermLevel = (rawPerms['media.view_admin']) ? 2 : myPermLevel;
      //
      //   M._permissions = {
      //     canEdit: rawPerms['media.update_others'] || isMyNote && rawPerms['media.update_mine'],
      //     canCreate: rawPerms['media.create'],
      //     canDelete: rawPerms['notes.destroy'] || false, // SATODO: Need to add in the time limit counter here. 5min grace period
      //     canView: M.permission <= myPermLevel,
      //     myPermLevel: myPermLevel
      //   };
      //
      //
      //   // SATODO: I don't think this should really be here... let's move this to saNote or wherever would need to know this
      //   // N._permissions.needsContextMenu = N._permissions.canEdit || N._permissions.canDelete;
      // }

      // M.$getPermissions = function() {
      //   var deferred = $q.defer();
      //
      //   if (M._permissions) {
      //     deferred.resolve(M._permissions);
      //   } else {
      //     UserPermissionsService.getCanDict(permissionsToFetch, M.organization_id || 'current')
      //       .then(function(dikt) {
      //         processRawPermissions(dikt);
      //
      //         deferred.resolve(M._permissions);
      //       }, function() {
      //         deferred.reject();
      //       });
      //   }
      //
      //   return deferred.promise;
      // };

      return O;
    };


    var OverrideTokens = {};
    // Medias.getGeneralPermissions = function(orgId) {
    //   return UserPermissionsService.getCanDict(permissionsToFetch, orgId || 'current');
    // };

    OverrideTokens.getById = function(id) {
      return $http.get(getBaseUrl() + '/' + id)
        .then(function(token) {
          return new OverrideToken(token.data);
        }, function(response) {
          return $q.reject(response);
        });
    }

    OverrideTokens.getOne = function(data) {
      var config = null;
      if (data) {
        config = {
          params: data
        };
      }

      return $http.get(getBaseUrl(), config || {})
        .then(function(response) {
          return (response.data) ? new OverrideToken(response.data) : null;
        }, function(response) {
          return $q.reject(response);
        });
    }

    OverrideTokens.revoke = function(id) {
      var params = {
        id: id,
        task: 'revoke'
      };

      return $http.post(getBaseUrl() + '/' + id, params)
        .then(function(token) {
          return new OverrideToken(token);
        }, function(response) {
          return $q.reject(response);
        });
    };

    OverrideTokens.consume = function(id) {
      var config = {
        params: {
          id: id,
          task: 'consume'
        }
      };

      return $http.post(getBaseUrl() + '/' + id, config)
        .then(function(token) {
          return new OverrideToken(token);
        }, function(response) {
          return $q.reject(response);
        });
    };

    OverrideTokens.create = function(data) {
      return $http.post(getBaseUrl(), data)
        .then(function(response) {
          return new OverrideToken(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    OverrideTokens.initWithData = function(initData) {
      return new OverrideToken(initData);
    };

    // Notes.destroy = function(noteId) {
    //   return $http.delete(getBaseUrl() + noteId)
    //     .then(function(response) {
    //       console.log("Deleted Note: " + noteId);
    //     }, function(response) {
    //       return $q.reject(response);
    //     })
    // }

    return OverrideTokens;
  });
